module.exports = __webpack_public_path__ + "static/media/khemka.51fef776.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/khemka.jpg
// module id = 1196
// module chunks = 0